import { EventPayload } from "../utils";

export const REQUEST_EXTERNAL_EVENT = "supernova-request-external-event";

export type RequiredFields = Omit<EventPayload, "type">;

/**
 * This indirection exists in order to decouple instances that may be
 * sprinkled throughout the application from the postMessage code and
 * have it parallel what's going on with the API requests and status
 * events
 */
export function emitExternalEvent(eventName: string, detail: any): void {
  window.dispatchEvent(
    new CustomEvent<RequiredFields>(REQUEST_EXTERNAL_EVENT, {
      detail: {
        eventName,
        detail,
      },
    })
  );
}

export function cleanAndEmitMosaicEvent(detail: any): void {
  const { metadata, originalEvent, uuid, ...cleanedDetail } = detail;
  emitExternalEvent(originalEvent, cleanedDetail);
}
